import { AxiosInstance } from "axios";
import {
  ResponseDto,
  IctResponseDto,
  ResponseLSDto
} from "@common/ict/model/interface/common";

export class NewsApi {
  static getNewsList(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/news/page/list",
      { params: params }
    );
  }

  static getNewsDetail(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/news/detail",
      { params: params }
    );
  }

  static getNewsCarousel(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/news/carousel",
      { params: params }
    );
  }

  static getNewsNumber(request: AxiosInstance) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/news/number"
    );
  }
  static getReportList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/subject/page/list`,
      {
        params: query
      }
    );
  }
  static getReportsNumber(request: AxiosInstance) {
    return request.get<ResponseDto, ResponseDto>(
      "zh-business/client/v1/subject/number"
    );
  }
  static getReportDetail(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/subject/detail`,
      {
        params: query
      }
    );
  }
}
